/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetMeResponseDataFromJSON, GetMeResponseDataToJSON } from './GetMeResponseData';
export function ConfirmMeChangeEmailResponseFromJSON(json) {
    return ConfirmMeChangeEmailResponseFromJSONTyped(json, false);
}
export function ConfirmMeChangeEmailResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetMeResponseDataFromJSON(json['data'])
    };
}
export function ConfirmMeChangeEmailResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetMeResponseDataToJSON(value.data)
    };
}
